import 'components/ordering/quotation/components/request/add-to-cart-button.js'
import 'components/ordering/quotation/components/request/answer-buttons.js'
import 'components/ordering/quotation/components/request/request-button.js'
import { html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

@customElement('csc-quotation-request-footer')
export class CSCQuotationRequestFooter extends LitElement {
  override render() {
    return html`
      <cse-group direction="row" justify="end" column-gap="0">
        <csc-quotation-request-button></csc-quotation-request-button>
        <csc-quotation-answer-buttons></csc-quotation-answer-buttons>
        <csc-quotation-add-to-cart-button></csc-quotation-add-to-cart-button>
      </cse-group>
    `
  }
}
